// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__209SA","name":"ConsentHeader_name__2LXlS","birthday":"ConsentHeader_birthday__2uFtA","skeleton":"ConsentHeader_skeleton__2hc9S"};